import { Button, Header, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { Offer } from './SalesGroupsList'

export interface IDeleteOfferProps {
  open: boolean
  onCancel: () => void
  onConfirm: (ArticleOfferUUID: string) => Promise<void>
  deletingOffer: Offer | null
  headerContent: string
  isLoading: boolean
}

export const DeleteOffer = (props: IDeleteOfferProps) => {
  const { t } = useTranslation()

  return (
    <Modal open={props.open} size='small' data-testid='delete-offer-modal'>
      <Header content={props.headerContent} />
      <Modal.Content>
        <p>
          {t('articleOffer.delete_offer.description')}
          <b>{` ${props.deletingOffer?.OfferDescription}`}</b>?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button content={t('global.cancel')} icon='cancel' onClick={props.onCancel} data-testid='btn-cancel' />
        <Button
          content={t('global.confirm')}
          color='blue'
          onClick={() => props.onConfirm(props.deletingOffer?.ArticleOfferUUID as string)}
          data-testid='btn-confirm'
          loading={props.isLoading}
        />
      </Modal.Actions>
    </Modal>
  )
}
export default DeleteOffer
